import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  createSubjectStart,
  editSubjectStart,
  getAllSubjectStart,
} from "../../../redux/subject/reducer";
import {
  selectIsCreatingSubject,
  selectIsEditingSubject,
} from "../../../redux/subject/selectors";
import {
  Box,
  Grid,
  Text,
  Button,
  Input,
  Spacer,
  TextArea,
  Select,
} from "@flexisaf/flexibull2";
import Theme from "../../../theme";
import { useForm } from "react-hook-form";
import fontSize from "../../../utils/typography";
import { DefaultCurriculum } from "../../../utils/constants";

const getDefaultFields = () => ({
  name: "",
  description: "",
  curriculumType: null,
});

const SubjectEditor = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsCreatingSubject);
  const isEditing = useSelector(selectIsEditingSubject);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      ...getDefaultFields(),
    },
    // mode: "onBlur",
  });

  useEffect(() => {
    if (props.data?.id) {
      reset({
        name: props?.data?.name,
        description: props?.data?.desc,
        curriculumType: props?.data?.curriculum
          ? {
              label: props?.data?.curriculum,
              value: props?.data?.curriculum,
            }
          : null,
      });
    } else {
      reset({
        ...getDefaultFields(),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.data]);

  const handleClose = () => {
    reset({
      ...getDefaultFields(),
    });
    props.closeModal();
  };

  const handleCreate = (v) => {
    const payload = {
      name: v.name,
      description: v.description,
      curriculum: v.curriculumType.value,
      cb: () => {
        dispatch(getAllSubjectStart());
        handleClose();
      },
    };

    dispatch(createSubjectStart(payload));
  };

  const handleEdit = (v) => {
    dispatch(
      editSubjectStart({
        ...v,
        id: props?.data?.id,
        cb: () => {
          dispatch(getAllSubjectStart());
          handleClose();
        },
      })
    );
  };

  return (
    <Box>
      <Grid default="auto max-content" responsive={false} className="bb">
        <Box pad="24px 32px">
          <Text {...fontSize.h3} uppercase>
            {props?.data?.id ? "Edit" : "Add a new"} subject
          </Text>
        </Box>
      </Grid>
      <Box pad="32px">
        <Spacer space="24px" />
        <Grid default="1fr " gap="24px">
          <Input
            spaceTop
            type="text"
            label={"Name"}
            required={true}
            placeholder={`Ex: Mathematics`}
            value={watch("name")}
            {...register("name", {
              required: `Name is required`,
            })}
            error={errors.name?.message}
            onChange={({ target: { value } }) => setValue("name", value)}
          />
          <Text color={Theme.SecondaryFontColor}>
            Subject name can be anything and this will eventually be tied to
            papers.
          </Text>
        </Grid>
        <Spacer space="24px" />
        <Grid default="1fr" gap="24px">
          <TextArea
            spaceTop
            type="text"
            label={"Description"}
            width="auto"
            required={false}
            placeholder={`Type in a short description for this subject`}
            value={watch("description")}
            error={errors.description?.message}
            onChange={({ target: { value } }) => setValue("description", value)}
          />
        </Grid>
        <Spacer space="30px" />
        <Grid default="1fr" gap="24px">
          <Select
            label="Paper Curriculum"
            required
            block
            placeholder="Select curriculum type"
            options={DefaultCurriculum?.map((item) => {
              return {
                label: item.label,
                value: item.value,
              };
            })}
            value={watch("curriculumType")}
            {...register("curriculumType", {
              required: "Select a curriculum type",
            })}
            error={errors?.curriculumType?.message}
            onChange={(value) => setValue("curriculumType", value)}
          />
        </Grid>
      </Box>

      <Grid default="auto max-content" responsive={false} className="bt">
        <Box pad="24px">
          <Button
            onClick={handleClose}
            pale
            color="rgba(0,0,0,0.0)"
            fontColor={Theme.PrimaryGrey}
          >
            Cancel
          </Button>
        </Box>
        <Box pad="24px">
          <Button
            onClick={handleSubmit((v) => {
              if (props?.data?.id) {
                handleEdit(v);
              } else {
                handleCreate(v);
              }
            })}
            progress={props?.data?.id ? isEditing : isLoading}
          >
            {props?.data?.id ? "Edit" : "Create"}
          </Button>
        </Box>
      </Grid>
    </Box>
  );
};

export default SubjectEditor;
